import BigNumber from "bignumber.js";
import { handleEmit } from ".";
import ERC20 from "../artifacts/contracts/ERC20MockContract.json";
import { getWeb3Sender, web3Reader } from "../wallet";

function getContractFactory(contractAddress, options) {
  const decimals = options?.decimals || 0;
  const web3Sender = getWeb3Sender();
  const BASE = Math.pow(10, decimals);
  var contractReader = new web3Reader.eth.Contract(ERC20.abi, contractAddress);
  var contractSender = new web3Sender.eth.Contract(ERC20.abi, contractAddress);

  if (!contractReader || !contractSender) {
    throw new Error(`Cannot create contract from address ${contractAddress}`);
  }

  return {
    getAllowance: async function (ownerAddress, spenderAddress) {
      const raw = await contractReader.methods.allowance(ownerAddress, spenderAddress).call();
      return BigNumber(raw).dividedBy(BASE);
    },
    approve: async function (spenderAddress, amount, accountAddress) {
      const _amount = BigNumber(amount).multipliedBy(BASE).toFixed();
      const emit = contractSender.methods.approve(spenderAddress, _amount).send({ from: accountAddress });
      handleEmit(emit, "approve");
      await emit;
    },
    getBalance: async function (accountAddress) {
      const raw = await contractReader.methods.balanceOf(accountAddress).call();
      return BigNumber(raw).dividedBy(BASE);
    },
  };
}

export default {
  getContractFactory,
};
